// Module
var code = "<div id=\"layout\" class=\"pure-g\"> <div id=\"chart\" class=\"pure-u-1\"> </div> <div id=\"controls\" class=\"pure-u\"> </div> </div>";
// Exports
module.exports = code;